export const FINALIZE_DETAILS='FINALIZE_DETAILS';